import { render, staticRenderFns } from "./UpdatesLogsSelectModal.vue?vue&type=template&id=225cbe3b&"
import script from "./UpdatesLogsSelectModal.vue?vue&type=script&lang=ts&"
export * from "./UpdatesLogsSelectModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports